/**
 * Dónde se mide qué.
 *
 * - Publicidad (Meta, TikTok, X, LinkedIn, Google Ads): SOLO en la superficie pública y en el
 *   embudo (landings, fichas, /inscripcion, auth, carrito, checkout, órdenes, certificados).
 *   Nunca adentro de una clase ni en el admin: lo que alguien hace mientras aprende no es dato
 *   de campaña, y el reproductor no tiene que competir con píxeles por la red.
 * - Analítica (GA4, PostHog, Clarity): en toda la app salvo el admin.
 */

const NO_ANALYTICS_PREFIXES = ["/admin"];

const NO_ADS_PREFIXES = [
  "/admin",
  "/course/",
  "/mi-aula",
  "/library",
  "/progress",
  "/settings",
  "/announcements",
  "/profile/",
  "/qa",
  "/articles",
];

const startsWithAny = (pathname: string, prefixes: string[]) =>
  prefixes.some((prefix) => pathname === prefix.replace(/\/$/, "") || pathname.startsWith(prefix));

export function isAnalyticsSurface(pathname: string) {
  return !startsWithAny(pathname, NO_ANALYTICS_PREFIXES);
}

export function isAdsSurface(pathname: string) {
  return !startsWithAny(pathname, NO_ADS_PREFIXES);
}
